{
  "info": {
    "stocks": {
      "tabs": {
        "analytics": "Analytics",
        "description": "Description",
        "statistics": "Statistics"
      }
    }
  }
}
